


















import CalendarTime from '@/components/Retailer/BookingCalendar/CalendarTime.vue';
import http from '@/services/Http';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { TimeSpan } from '@/models/CalendarEntries';

@Component({
  components: {
    CalendarTime,
  },
})
export default class CalendarDay extends Vue {
  @Prop() private date!: Date;
  @Prop() private times!: TimeSpan[];
  get translations(): any {
    // const tObj = (window as any).__litium.translation;
    return {
      dayNames: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      monthNames: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
    };
  }
  get isToday(): boolean {
    const today = new Date();
    return this.date.getDate() === today.getDate() &&
      this.date.getMonth() === today.getMonth() &&
      this.date.getFullYear() === today.getFullYear();
  }
  get dayNameString(): string {
    return this.translations.dayNames[this.date.getDay()];
    // return this.dayNames[this.date.getDay()];
  }
  get dateAndMonth(): string {
    return this.date.getDate() + ' ' + this.translations.monthNames[this.date.getMonth()];
  }
  get classObject(): object {
    return {
      today: this.isToday,
    };
  }
}
